import { useEffect } from 'react';
import { useAuthStore } from 'stores/auth-store';
import { getWebAppOrigin } from 'utils/web-app-url';

function isLoginPath() {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.location.pathname.startsWith('/login');
}

/**
 * Landing no longer keeps a workshop session.
 * On every load: clear any stored token, bounce /login/ to the app.
 */
export function useTokenBootstrap() {
  useEffect(() => {
    useAuthStore.getState().clearSession();

    if (isLoginPath()) {
      window.location.replace(getWebAppOrigin());
    }
  }, []);

  return { authPending: false };
}
